import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FontSizes from '../../constants/FontSizes';

const ActivateScreen = () => {
    return (
        <View style={styles.screen}>
            <Text style={styles.messageText}>If you wish to activate your account, please speak with your administrator so they can email you a link to set up your password.</Text>
        </View>
    )
}

export const screenOptions = () => {
    return {
        headerTitle: "Account Activation"
    }
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
        padding: 30
    },
    messageText: {
        fontSize: FontSizes.large,
        lineHeight: 30
    }
});

export default ActivateScreen;

